import { useMemo, useState } from 'react'

import {
  SHIPPINGS_STATIC_DEFAULT_FILTERS,
  SHIPPING_STATUS_CODES,
} from '../../common/constants'

const HOME_SUMMARY_PAGINATION_PARAMS = {
  page: 0,
  rowsPerPage: 5,
}
export const DEFAULT_SHIPPING_STATUS_FILTER = SHIPPING_STATUS_CODES.manifested

const getShippingTrackingDefaultFilters = dynamicBaseFilters => ({
  ...SHIPPINGS_STATIC_DEFAULT_FILTERS,
  ...HOME_SUMMARY_PAGINATION_PARAMS,
  hasIncident: false,
  ...dynamicBaseFilters,
})

const useHomeFilters = dynamicBaseFilters => {
  const defaultFilters = useMemo(
    () => getShippingTrackingDefaultFilters(dynamicBaseFilters),
    [dynamicBaseFilters],
  )

  const [filters, setFilters] = useState(defaultFilters)
  const [tabValue, setTabValue] = useState()

  const handleChangeView = statusCode => {
    if (statusCode === SHIPPING_STATUS_CODES.incidents) {
      setFilters(filters => ({
        ...filters,
        hasIncident: true,
      }))
      setTabValue(SHIPPING_STATUS_CODES.incidents)
    } else {
      setFilters(filters => ({
        ...filters,
        hasIncident: false,
      }))
      setTabValue(statusCode)
    }
  }

  return {
    tabValue,
    filters: { ...filters, ...dynamicBaseFilters },
    handleChangeView,
  }
}

export default useHomeFilters
